import { dynamicImage, Image } from "../../Utils";

const bodyData = (
  <p>
    <Image className="img-fluid faq-decor" src={dynamicImage("landing/chatzy/2.png")} alt="chit-chat-back-img" />
    it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for &apos;lorem ipsum&apos; will uncover many web sites still in their infancy. Various versions have evolved over the years,All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures
  </p>
);

export const FAQData = [
  { id: "1", accordionHeading: "How can I downgrade to an earlier ?", bodyText: bodyData },
  { id: "2", accordionHeading: "How can I upgrade from Shopify 2.5 to shopify 3?", bodyText: bodyData },
  { id: "3", accordionHeading: "Under what license are Regular Labs released?", bodyText: bodyData },
  { id: "4", accordionHeading: "What is the Regular Labs Library?", bodyText: bodyData },
  { id: "5", accordionHeading: "Can I turn on/off some blocks on the page?", bodyText: bodyData },
  { id: "6", accordionHeading: "What is included in the template package?", bodyText: bodyData },
  { id: "7", accordionHeading: "Integrating WordPress with Your Website?", bodyText: bodyData },
];
